import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { PageService } from '../services/page.service';
import { ThemeService } from '../../shared/services/theme.service';
@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {
  @ViewChild('speakerModal') speakerModal!: ElementRef;
  selectedSpeaker: any;
  registerForm: UntypedFormGroup;
  isSubmitted: boolean = false;
  eventId: any;
  defaultImage = 'assets/images/banner-placeholder.jpg';
  eventDetail: any;
  safeYoutubeUrl: SafeResourceUrl = '';
  isEventEnd: boolean = false;
  isLoading: boolean = true;
  youtubeID: string | null = '';
  errors: any;
  invalidForm: boolean;
  isFormSaving: boolean;
  isFormShow: boolean;
  currentTheme: string;
  defaultProfileImage = 'assets/images/thumb/no-thumb.jpeg';


  constructor(
    public fb: UntypedFormBuilder,
    public themeService: ThemeService,
    private el: ElementRef,
    private pageService: PageService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
    this.registerForm = this.fb.group(
      {
        name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        job_title: [''],
        company: [''],
        contact_phone: ['']
      }
    );
    this.themeService.themes.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit() {
    this.eventId = this.route.snapshot.params['id'];
    this.eventDetail = null;
    this.getEventDetail();
  }

  getEventDetail() {
    this.pageService.getEventDetail(this.eventId).subscribe(data => {
      this.eventDetail = data;
      if (this.eventDetail?.status === 'up_coming') {
        this.eventDetail.description = this.eventDetail.description
          ? this.eventDetail.description.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>')
          : '';
      }
      this.isLoading = false;
      const currentDate = new Date();
      const eventDate = new Date(data.start_time);
      const isEventPast = currentDate > eventDate;
      if (isEventPast) {
        this.isEventEnd = true;
      } else {
        this.isEventEnd = false;
      }
      if (this.eventDetail.youtube_url) {
        this.youtubeID = this.extractYouTubeVideoId(this.eventDetail?.youtube_url);
        this.safeYoutubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.youtubeID);
      }
    }, error => {
      console.error(error);
    });
  }

  onFormSubmit() {
    this.invalidForm = true;
    this.isFormShow = false;
    if (this.registerForm.valid) {
      this.invalidForm = false;
      this.isFormSaving = true;
      const userData = this.registerForm.value;
      const eventId = this.eventId;
      userData.event_id = eventId;
      this.pageService.registerUser(userData).subscribe({
        next: (response) => {
          this.isSubmitted = true;
          this.isFormSaving = false;
          this.isFormShow = true;
          this.registerForm.reset();
        }, error: (error) => {
          this.isFormSaving = false;
          this.isFormShow = false;
          this.errors = error ? error : null;
        }
      }
      );
    } else {
      this.invalidForm = true;
      const target = this.el.nativeElement.querySelector('.ng-invalid:not(form):not(div)');
      if (target) {
        target.focus();
      }
    }
  }

  extractYouTubeVideoId(url: string): string | null {
    const urlObj = new URL(url);
    const videoId = urlObj.searchParams.get('v');
    return videoId;
  }
  showModal(speaker: any) {
    this.selectedSpeaker = speaker;
    this.speakerModal.nativeElement.open = !this.speakerModal.nativeElement.open;
  }



  onError(event: any) {
    event.target.src = this.defaultImage;
  }

  onProfilePicError(event: any) {
    event.target.src = this.defaultProfileImage;
  }
}

